<div *ngIf="tour === EMPTY_OBJECT" class="loading">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</div>
<div
  *ngIf="tour == null || tour.tourItems?.length === 0"
  class="horizontal-center"
>
  Geen uit te voeren opdrachten op deze dag
</div>
<div *ngIf="tour != null && tour.tourItems?.length > 0" class="ipad-container">
  <div class="d-flex justify-content-between">
    <div class="select-view-buttons flex-33">
      <button
        mat-flat-button
        [ngClass]="
          selectedView === SELECTABLE_VIEWS.IMMO_IP_PLACER_TOUR_LIST_VIEW
            ? 'active'
            : 'inactive'
        "
        (click)="
          setSelectedView(SELECTABLE_VIEWS.IMMO_IP_PLACER_TOUR_LIST_VIEW)
        "
      >
        Opdrachten
      </button>
      <button
        mat-flat-button
        [ngClass]="
          selectedView === SELECTABLE_VIEWS.IMMO_IP_PLACER_TOUR_ROUTE_VIEW
            ? 'active'
            : 'inactive'
        "
        (click)="
          setSelectedView(SELECTABLE_VIEWS.IMMO_IP_PLACER_TOUR_ROUTE_VIEW)
        "
      >
        Route
      </button>
    </div>
    <div class="flex-33 in-the-middle">
      <ng-container
        *ngIf="!storingTourRouteChecked; else savingTourRouteChecked"
      >
        <div class="route-checked-checkbox">
          <mat-checkbox
            [(ngModel)]="tour.routeChecked"
            (ngModelChange)="submitTourRouteChecked()"
            >Route klaar</mat-checkbox
          >
        </div>
      </ng-container>
      <ng-template #savingTourRouteChecked>
        <mat-spinner color="primary" diameter="24"></mat-spinner>
      </ng-template>
    </div>
    <div class="flex-33"></div>
  </div>
  <div class="upper-space">
    <ng-container
      *ngIf="selectedView === SELECTABLE_VIEWS.IMMO_IP_PLACER_TOUR_LIST_VIEW"
    >
      <immo-ip-placer-tour-list [tour]="tour"></immo-ip-placer-tour-list>
    </ng-container>
    <ng-container
      *ngIf="selectedView === SELECTABLE_VIEWS.IMMO_IP_PLACER_TOUR_ROUTE_VIEW"
    >
      <immo-ip-placer-tour-route
        [tour]="tour"
        [tourDateChangedOrDestroy]="tourDateChangedOrDestroy"
      ></immo-ip-placer-tour-route>
    </ng-container>
  </div>
</div>
